import React from "react";

const CloudSecurity = () => {
  return (
    <div className="p-4">
      Cloud security refers to the practices, technologies, and policies
      designed to protect data, applications, and infrastructure hosted in the
      cloud from cyber threats. It ensures confidentiality, integrity, and
      availability of resources in cloud environments by addressing risks like
      data breaches, unauthorized access, and service disruptions. Key aspects
      of cloud security include encryption, access control, threat detection,
      compliance monitoring, and incident response. Effective cloud security
      balances robust protection with user accessibility, enabling organizations
      to safely leverage the scalability and flexibility of cloud computing.
    </div>
  );
};

export default CloudSecurity;
